import { giftReceiptSchema } from "@redotech/redo-model/gift-receipt/gift-receipt";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export enum GetGiftReceiptErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT FOUND",
  COULD_NOT_PARSE = "COULD NOT PARSE",
}

export const getGiftReceipt = {
  name: "getGiftReceipt" as const,
  input: z.object({ giftReceiptId: zExt.objectId() }),
  output: z.object({ giftReceipt: giftReceiptSchema, link: z.string() }),
};
